<template>
  <v-col cols="1" offset="1" align-self="center">
    <v-btn
      v-if="scroll && scroll.prev"
      fab
      small
      color="rgba(0,0,0,0.3)"
      @click="onScrollUp(scroll.prev)"
    >
      <v-icon color="rgb(192,192,192)	">mdi-arrow-up</v-icon>
    </v-btn>
    <v-btn
      v-if="scroll && scroll.next"
      fab
      small
      color="rgba(0,0,0,0.3)"
      @click="onScrollDown(scroll.next)"
    >
      <v-icon color="rgb(192,192,192)">mdi-arrow-down</v-icon>
    </v-btn>
  </v-col>
</template>

<script>
export default {
  name: "ScrollHelper",
  props: ["scroll"],
  methods: {
    onScrollUp: (id) => {
      // console.log(this.scroll);
      console.log("scrollup");
      document.getElementById(id).scrollIntoView({
        behavior: "auto",
        block: "center",
        inline: "center",
      });
    },
    onScrollDown: (id) => {
      // console.log(this.scroll.next);
      document.getElementById(id).scrollIntoView({
        behavior: "auto",
        block: "center",
        inline: "center",
      });
    },
  },
};
</script>
